import React from 'react'
import classNames from 'classnames'
import './index.less'

export default ({ children, className }) => {
  return <div className={classNames('mn-steps', className)}>
    {children}
  </div>
}

export const Step = ({ title, active }) => {
  return <div className={classNames('mn-steps-item', { active })}>
    <div className="mn-steps-item-point" />
    <div className="mn-steps-item-line" />
    {title}
  </div>
}
